import { BaseType } from '../../base/base-type';
import { PronounTypeEnum } from '../enum/pronoun-type.enum';

export class Pronoun extends BaseType {
  // @ts-ignore
  public id: PronounTypeEnum = 0;
}
